<template>
  <div class="welcome">
    <span v-html="showWelcomeContent"></span>
  </div>

  <!--BUTTONS-->
  <div class="buttons" id="start-buttons">
    <QppButton :buttons="buttons"></QppButton>
  </div>
</template>

<script>
import store from "@/store";
import QppButton from "@/components/common/QppButton";
import screenApiService from "@/services/screenApiService";

export default {
  name: 'LandingPage',
  components: {QppButton},
  data() {
    return {
      buttons: [],
    }
  },
  computed: {
    showWelcomeContent() {
      return this.$store.state.siteTheme.landingContent
    },
    disableButtons() {
      return this.$store.state.disableButtons
    }
  },
  mounted() {
    store.commit('showModal', false);
    this.screenProperties = store.state.currentScreenProperties;
    this.buttons = store.state.currentScreenOptions;
    if (document.readyState !== 'loading') {
      setTimeout(this.addHandAnimation, 500);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(this.addHandAnimation, 500);
      });
    }
  },
  methods: {
    addHandAnimation() {
      let startIcon = document.getElementsByClassName('start-button');
      const elem = document.createElement('i');
      if (startIcon && startIcon.length > 0) {
        let parentButton = startIcon[0].parentElement;
        elem.classList.add("fa", "fa-hand-point-right", 'fa-3x', 'text-color', "hand-pointer-start");
        if (parentButton)
          parentButton.prepend(elem)
      }
    },
    goToStartScreen() {
      store.state.disableButtons = true;
      screenApiService.getStartScreen();
    }
  }
}
</script>
